<template>
  <!-- ================= NAVBAR ================= -->
  <nav class="topbar">
    <div class="logo">Shri Vinayak CMS</div>

    <ul class="menu">
      <li
        v-for="(item, key) in sidebarItems"
        :key="key"
        class="menu-item"
        @mouseenter="dropdowns[key] = true"
        @mouseleave="dropdowns[key] = false"
      >
        <span class="menu-title">
          {{ item.title }}
          <span class="arrow">▾</span>
        </span>

        <ul v-show="dropdowns[key]" class="dropdown">
          <li v-for="(sub, i) in item.subItems" :key="i">
            <a @click.prevent="navigateToRoute(sub.link, sub.name)">
              {{ sub.name }}
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <button class="admin-btn" @click="redirectToAdmin">
      Admin Panel
    </button>
  </nav>

  <!-- ================= DASHBOARD ================= -->
  <main class="dashboard">
    <section class="hero">
      <h1>Factory Management Dashboard</h1>
      <p>Attendance • Employee • Purchases • Khata • Suspance • Sell Product</p>
    </section>

    <section class="cards">
      <div class="card">👨‍💼 Employees</div>
      <div class="card">📅 Attendance</div>
      <div class="card">🧾 Purchases</div>
      <div class="card">💰 Sales</div>
    </section>

    <section class="action-section">
      <h2>Business Actions</h2>
      <div class="action-cards">
        <div class="action-card khata">📘 Khata Management</div>
        <div class="action-card suspance">⏳ Suspance</div>
        <div class="action-card sell">🧾 Sell Product</div>
      </div>
    </section>
  </main>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const navigateToRoute = (path, name) => {
  router.push({ path, query: { name } });
};

const redirectToAdmin = () => {
  router.push("/Admin");
};

/* ========= DROPDOWNS (TUMHARA DATA) ========= */
const dropdowns = ref({
  attendence: false,
  employee: false,
  purchases: false,
  sales: false,
  khata: false,
  anlysis: false,
  sell_product: false,
});

/* ========= SIDEBAR ITEMS (100% SAME) ========= */
const sidebarItems = {
  attendence: {
    title: "Attendance",
    subItems: [
      { name: "Jinning Mistri", link: "/Employee-Attendance" },
      { name: "Saplar", link: "/Employee-Attendance" },
      { name: "Jharkhand (Labor)", link: "/Employee-Attendance" },
      { name: "Bihari Labor", link: "/Employee-Attendance" },
      { name: "Packaging", link: "/Employee-Attendance" },
      { name: "Munim", link: "/Employee-Attendance" },
      { name: "Sr Manager", link: "/Employee-Attendance" },
      { name: "Market Manager", link: "/Employee-Attendance" },
      { name: "Driver", link: "/Employee-Attendance" },
    ],
  },

  employee: {
    title: "Employee",
    subItems: [
      { name: "Add Employees", link: "/Add-Employee" },
      { name: "Employee Payroll", link: "/selery-Managment" },
      { name: "Employee Payroll History", link: "/Departments" },
    ],
  },

  purchases: {
    title: "Purchases",
    subItems: [
      { name: "+ Mandi Purchase Data", link: "/Mandi-purchase-form" },
      { name: "+ Direct Purchase Data", link: "/direct-purchase-Form" },
      { name: "+ Brocker Purchase Data", link: "/broker-purchase-Form" },
    ],
  },

  sales: {
    title: "Purchase Data",
    subItems: [
      { name: "Mandi Purchase", link: "/Mandi-Purchase-Detail" },
      { name: "Direct Purchase", link: "/Driect-Purchase-Detail" },
      { name: "Brocker Purchase", link: "/Brocker-Purchase-Detail" },
    ],
  },

  khata: {
    title: "Khata",
    subItems: [
      { name: "Musterd-Oil KhataBook", link: "/Mustard-Oil-khatabook" },
      { name: "Cutton-Cake KhataBook", link: "/Cotton-Cake-khatabook" },
      { name: "Row of MusterdOil KhataBook", link: "/Row-Of-MustardOil-khatabook" },
      { name: "Row Of CuttonCake KhataBook", link: "/Row-of-cutton-khatabook" },
    ],
  },

  anlysis: {
    title: "Suspance",
    subItems: [
      { name: "Add Suspance", link: "/Suspance-form" },
      { name: "Suspance History", link: "/Suspance-History" },
    ],
  },

  sell_product: {
    title: "Sell Product",
    subItems: [
      { name: "Generate Bill", link: "/Sell-product-Form" },
      { name: "See Biils", link: "/Suspance-History" },
    ],
  },
};
</script>

<style scoped>
/* RESET */
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* NAVBAR */
.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #020617;
  padding: 14px 32px;
  color: white;
}

.logo {
  font-size: 22px;
  font-weight: 700;
}

.menu {
  display: flex;
  gap: 26px;
}

.menu-item {
  position: relative;
}

.menu-title {
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 600;
}

.menu-title:hover {
  background: rgba(255, 255, 255, 0.1);
}

.arrow {
  font-size: 12px;
  margin-left: 4px;
}

/* DROPDOWN */
.dropdown {
  position: absolute;
  top: 120%;
  left: 0;
  background: white;
  min-width: 260px;
  max-height: 320px;
  overflow-y: auto;
  padding: 8px;
  border-radius: 10px;
  box-shadow: 0 20px 40px rgba(0,0,0,.2);
  z-index: 100;
}

.dropdown li {
  padding: 10px;
  border-radius: 6px;
}

.dropdown li:hover {
  background: #0ea5e9;
}

.dropdown li a {
  color: #020617;
  text-decoration: none;
  font-weight: 500;
}

.dropdown li:hover a {
  color: white;
}

/* ADMIN BUTTON */
.admin-btn {
  background: linear-gradient(135deg,#facc15,#f97316);
  border: none;
  padding: 10px 18px;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
}

/* DASHBOARD */
.dashboard {
  padding: 40px;
  background: #f4f7fc;
  min-height: calc(100vh - 70px);
}

.hero h1 {
  font-size: 32px;
}

.hero p {
  color: #64748b;
}

/* CARDS */
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(220px,1fr));
  gap: 24px;
  margin-top: 30px;
}

.card {
  background: white;
  padding: 30px;
  border-radius: 16px;
  font-weight: 600;
  box-shadow: 0 20px 35px rgba(0,0,0,.08);
  transition: transform .3s;
}

.card:hover {
  transform: translateY(-6px);
}

/* ACTION CARDS */
.action-section {
  margin-top: 50px;
}

.action-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(240px,1fr));
  gap: 24px;
}

.action-card {
  padding: 28px;
  border-radius: 18px;
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: transform .3s;
}

.action-card:hover {
  transform: translateY(-8px);
}

.khata {
  background: linear-gradient(135deg,#2563eb,#1e40af);
}

.suspance {
  background: linear-gradient(135deg,#f97316,#c2410c);
}

.sell {
  background: linear-gradient(135deg,#16a34a,#065f46);
}
</style>
